import { ComponentType, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonProps } from '@qga/roo-ui/components';
import ButtonWithLoadingIndicator from './ButtonWithLoadingIndicator';

interface LoadingButtonProps extends ButtonProps {
  buttonComponent?: ComponentType;
  loading?: boolean;
  children: ReactNode;
  onClick?: any;
}

const LoadingButton = ({ buttonComponent: ButtonComponent = Button, loading = false, ...props }: LoadingButtonProps) => {
  if (loading) {
    return <ButtonWithLoadingIndicator {...props} />;
  } else {
    return <ButtonComponent {...props} />;
  }
};

LoadingButton.propTypes = {
  ...Button.propTypes,
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default LoadingButton;
